module.exports = __webpack_public_path__ + "static/media/fire-safes.df8f10e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/fire-safes.png
// module id = 1287
// module chunks = 0